import * as React from "react";

export interface InputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className = "", ...props }, ref) => {
        return (
            <input
                ref={ref}                                    // <-- quan trọng cho RHF
                className={
                    "w-full rounded-md border px-3 py-2 text-sm " +
                    "focus:outline-none focus:ring-2 focus:ring-offset-2 " +
                    "border-neutral-300 focus:ring-neutral-800 " +
                    className
                }
                {...props}                                   // <-- đừng override value/onChange của RHF
            />
        );
    }
);
Input.displayName = "Input";

export default Input;
